module.exports = __webpack_public_path__ + "static/media/61.f728bf97.JPG";